import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { VideoReel } from "@/components/site/VideoReel";
import { Services } from "@/components/site/Services";
import { Testimonials } from "@/components/site/Testimonials";
import { Footer } from "@/components/site/Footer";
import { Toaster } from "@/components/ui/sonner";

const Landing = () => {
    return (
        <main className="bg-[#0A0A0A] text-white min-h-screen" data-testid="landing-root">
            <Header />
            <Hero />
            <VideoReel />
            <Services />
            <Testimonials />
            <Footer />
        </main>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                </Routes>
            </BrowserRouter>
            <Toaster />
        </div>
    );
}

export default App;
